import { css } from '@emotion/react';

const card = css`
  padding: 10px !important;
  color: black;
  text-align: left;
  width: 100% !important;
  min-width: 250px !important;
`;

const vat = css`
  font-size: x-small;
`;

const invoiceContact = css`
  font-size: x-small;
`;

const addCard = css`
  min-height: 200px !important;
  padding: 20px !important;
  align-items: center;
  justify-content: center;
  width: 100% !important;
`;

const addCardText = css`
  padding: 10px;
`;

export default {
  card,
  vat,
  addCard,
  addCardText,
  invoiceContact,
};
